<template>
  <footer>
    <div class="outer-footer-wrap">
      <!--
      <div id="footer-grid">
        <div id="footer-left">
          <h2>News</h2>
        </div>
        <div id="footer-middle">
          <h2>Stuff</h2>
        </div>
        <div id="footer-right">
          <h2>Stay in contact</h2>
          <a href="https://www.youtube.com/channel/UCedzYVwHVqXLptM-vdEOUGA">YouTube</a><br>
          <a href="#">Facebook</a><br>
          <a href="#">Instagram</a><br>
        </div>
      </div>-->
      <div class="footertext">
        © {{ currentYear }} | Forward Audio | 
        <NuxtLink to="/imprint" :title="imprintName">{{ imprintName }}</NuxtLink> | 
        <NuxtLink to="/privacypolicy" :title="privacyName">{{ privacyName }}</NuxtLink>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';

const currentYear = computed(() => new Date().getFullYear());

const imprintName = ref('Imprint');
const privacyName = ref('Privacy Policy');

onMounted(() => {
 /* const userLang = navigator.language || navigator.userLanguage;
 if (userLang === 'de' || userLang.startsWith('de-')) {
    imprintName.value = 'Impressum';
    privacyName.value = 'Datenschutz';
  }*/
});
</script>

<style scoped lang="scss">
@import '~/assets/constants.scss';

#footer-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 2rem;
    width: 100%;
    color: #c0c0c0;
    font-size: 1.15rem;
}

.outer-footer-wrap a {
  color: #c0c0c0;
}

.outer-footer-wrap a:hover {
  color: $light-white;
}

#footer-grid h2 {
    color: #c0c0c0;
    font-size: 1.75rem;
}

.outer-footer-wrap 
{
    box-shadow: 0 -2px 7px rgba(0, 0, 0, 0.9);
    background: #222;
    background-image: linear-gradient(to top, $header-gray, $light-black);
    //background-image: linear-gradient(to bottom, $light-black, $header-gray);
    display: flex; 
    justify-content: center; 
    padding: 2rem;
    flex-direction: column;
}

.footertext {
    margin-top: 1rem;
    text-align: center;
    font-size: 0.85rem;
    color: #c0c0c0;
}

@include respond-to("phone-only") {

#footer-grid {
  display: none;
}

.outer-footer-wrap {
  padding: 0.75rem;
}

}



</style>